import { UnstyledButton, UnstyledButtonProps } from '@mantine/core';
import React from 'react';
import classes from './InlineClickableText.module.css';

type InlineClickableTextProps = UnstyledButtonProps & {
  onClick?: () => void;
  children: React.ReactNode;
};

export const InlineClickableText = (props: InlineClickableTextProps) => {
  return (
    <UnstyledButton {...props} component={'label'} className={classes.inlineClickableText}>
      {props.children}
    </UnstyledButton>
  );
};
